import { vmFollowPopularCompany } from './../components';

/**
 * モーダル内に人気企業を表示する
 *
 * @param {array} companyList フォローリスト
 */
export function popupFollowPopularCompany (companyList) {
  function updateView () {
    vmFollowPopularCompany.$data.isShow = true;
    companyList.forEach(x => {
      vmFollowPopularCompany.$data.dataList.push(x);
    });
  }

  function init () {
    updateView();
  }

  init();
}
